import React from 'react';
import { translate } from 'react-translate';
import Button from '@components/Button';
import CustomModal from '@components/CustomModal/CustomModal';
import ImageDropZone from './ImageDropZone';
import * as S from './styles';

const ModalChangeImages = (props) => (
  <CustomModal visible={props.isOpenChangeImageModal} onClickAway={props.toggleChangeImageModal}>
    <S.CustomModalContent>
      <S.Croppers>
        <ImageDropZone
          style={{ width: '176px', height: '176px' }}
          anySize
          showButton
          width={180}
          height={180}
          imageDefault="https://bgdk8s.blob.core.windows.net/bornlogic/image-default-avatar.png"
          imagePicked={(image) => props.onDrop(image, true)}
        />
        <ImageDropZone
          style={{ width: '816px', height: '356px' }}
          anySize
          showButton
          width={820}
          height={360}
          imageDefault="https://bgdk8s.blob.core.windows.net/bornlogic/image-default-capa.png"
          imagePicked={(image) => props.onDrop(image)}
        />
      </S.Croppers>

      <S.SaveButton>
        <Button onClick={props.postNewImages}>{props.t('CONFIRM')}</Button>
      </S.SaveButton>
    </S.CustomModalContent>
  </CustomModal>
);

export default translate('ProfileAndCover')(ModalChangeImages);
